<div class="powerbi-multiple-pages-component">
  <div class="report-tab-container">
    <div class="arrow left" *ngIf="showLeftArrow" (click)="scrollLeft()"><mat-icon>arrow_back_ios</mat-icon></div>
    <div class="report-tab" (window:resize)="checkArrows()" #reportTab>
      <ul>
        <ng-container *ngFor="let page of report_data?.pb_container; trackBy: trackByMenuName">
          <li (click)="SelectTab(page)" [ngClass]=" {'active' : (activeTabName?.page_name === page.page_name) }">
            {{ page.label | langtranslate}}
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="arrow right" *ngIf="showRightArrow" (click)="scrollRight()"><mat-icon>arrow_forward_ios</mat-icon></div>
  </div>
  <div class="divider" *ngIf="overViewMenu?.length && activeTabName?.child_header">
    <app-report-sub-menu [menuList]="overViewMenu"
      [activeTab]="currentScroll" (menuChangeValue)="menuChangeValue($event)">
    </app-report-sub-menu>
  </div>
</div>
<div class="page-view-container">
  <ng-container *ngFor="let page of report_data?.pb_container">
    <div [ngStyle]="{'display': (activeTabName?.page_name === page.page_name) ? 'block' : 'none'}">
      <ng-container *ngFor="let main_container of page.pb_container">
        <div class="items report-tabsection" id="{{ main_container.sort_order }}"
          [class.col1]="main_container.items.length == 1" [class.col2]="main_container.items.length == 2"
          [class.col3]="main_container.items.length == 3" [class.col4]="main_container.items.length == 4">
          <ng-container *ngFor="let item of main_container.items; index as i">
            <div class="item-card" [style]="{ width: main_container.width, height: main_container.height}">
              <div [attr.id]="page.page_name+'_visualOne_' + item?.visualId +'_'+i" class="visual-one"
                style="width: 100%; height:100%">
              </div>
            </div>
          </ng-container>
          <div class="loading-gif" *ngIf="main_container?.loader">
            <img src="assets/images/loading.gif" alt="" height="150px">
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

</div>
